import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class TasUnifiedInstitutionModel extends Model {
  @attr declare isFeatured: boolean;
  @attr declare isPreferred: boolean;

  @attr declare dapipId: number;
  @attr declare institutionId: string;
  @attr declare address: string;
  @attr declare locationName: string;
  @attr declare locationType: string;
  @attr declare lpn: boolean;

  [Type] = 'tas-unified-institution' as const;
}
